<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">{{currentParams.name}}</p>
      <p class="update-time">{{currentParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>接口名称</span>
      </div>
      <div class="module-text">
        <span>{{currentParams.url}}</span>
      </div>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>请求方式</span>
      </div>
      <div class="module-text">
        <span>POST</span>
      </div>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>请求参数</span>
      </div>
      <div class="table-box">
        <tables :params-data="currentParams.request"></tables>
      </div>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>请求示例</span>
      </div>
      <div class="code-example">
        <json-viewer :value="currentParams.code"
                     :expand-depth="5"
                     boxed
                     copyable></json-viewer>
      </div>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>响应参数</span>
      </div>
      <div class="table-box">
        <tables :params-data="currentParams.reseponse"></tables>
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import skuInfoApi from "../../../../api/sku/info.js";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: skuInfoApi
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      font-size: 14px;
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>